import React from 'react';
import Proptypes from 'prop-types';
import cx from 'classnames';

import { LIST_ITEM_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { LIST_ITEM_TAG_NAME } from './constants';
import styles from './ListItem.css';

const renderer = ({
  node: { type },
  LIST_ITEM_TAG = LIST_ITEM_TAG_NAME,
  ...attributes
}) => {
  if (type === LIST_ITEM_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <LIST_ITEM_TAG
        {...restOfAttributes}
        className={cx(styles.listItem, attributes.className)}
      >
        {children}
      </LIST_ITEM_TAG>
    );
  }
};

renderer.Proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
};

export { renderer };
